/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
var u = /* @__PURE__ */ ((e) => (e.next = "next", e.prev = "prev", e.current = "current", e.reset = "reset", e))(u || {});
const s = (e, r) => {
  const t = r.items.findIndex((n) => n === e);
  switch (r.type) {
    case "next":
      return t === r.items.length - 1 ? e : r.items[t + 1];
    case "prev":
      return t === 0 ? e : r.items[t - 1];
    case "current":
      return r.payload;
    case "reset":
      return null;
    default:
      return e;
  }
};
export {
  u as FOCUS_ACTION,
  s as focusReducer
};
